import {BsTwitter} from 'react-icons/bs'
import {FaFacebookF} from 'react-icons/fa'
import {AiFillYoutube} from 'react-icons/ai'

const SocialMedia = () => {
  return (
    <div className='social-container'>
        <a href="https://twitter.com/AliquamStudios" rel="noreferrer" target='_blank'><BsTwitter/></a>
        <a href="https://www.facebook.com/AliquamStudios/" rel="noreferrer" target='_blank'><FaFacebookF/></a>
        <a href="https://www.youtube.com/@aliquamstudios9506" rel="noreferrer" target='_blank'><AiFillYoutube/></a>
    </div>
  )
}

export default SocialMedia